import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "slices"; // Combined reducers

export const store = configureStore({
    reducer: rootReducer, devTools: true, middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

